import { render, staticRenderFns } from "./unit-logs.vue?vue&type=template&id=b8205830&"
import script from "./unit-logs.vue?vue&type=script&lang=js&"
export * from "./unit-logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports